import axios from 'axios';

const defaultHeaders = {
  // Mandatory params
  Application: HEADERS_APPLICATION,
  Locale: 'it',
  Channel: 'web',
  // Custom params
  Env: DEPLOY_ENV_NAME,
  'Content-Type': 'application/json',
  Accept: 'application/json, text/plain, */*',
  pragma: 'no-cache',
  'Client-version': "'web'",
  'cache-control': 'no-cache'
}

// const delay =  (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const getMarketingAutomationInfo = async (params) => {
  const url = `${API_BASE_URL}/getMktaInfo`;
  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: { ...params },
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
      return { response };
    }
  } catch (error) {
    return { error };
  }

  // try {
  //     return axios.get('/mock/banner/API_getMktaInfo.json')
  //       .then((response) => {
  //         return { response };
  //       })
  //   } catch (error) {
  //     return { error };
  //   }
}

export const retrieveTemplate = async (params) => {
  const url = `${API_BASE_URL}/retrieveTemplate`
  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: { ...params },
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
      return { response };
    }
  } catch (error) {
    return { error };
  }
}
export const saveTemplate = async (params) => {
  const url = `${API_BASE_URL}/saveTemplate`;
  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: { ...params },
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
      return { response };
    }
  } catch (error) {
    return { error };
  }
}

export const retrieveIds = async (params) => {
  const url = `${API_BASE_URL}/retrieveIds`;
  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: { ...params },
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
      return { response };
    }
  } catch (error) {
    return { error };
  }
}

export const startCampaign = async (params) => {
  const url = `${API_BASE_URL}/startCampaign`;
  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: { ...params },
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
      return { response };
    }
  } catch (error) {
    return { error };
  }
}


export const getBannerQueue = async (params) => {
  // await delay(1000);

  const url = `${API_BASE_URL}/banner/queue/get-preview`;
  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: {...params},
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
      return { response };
    }
  } catch (error) {
    return { error };
  }

  // try {
  //   return axios.get('/mock/banner/API_getBannerQueueModal.json')
  //     .then((response) => {
  //       return { response };
  //     })
  // } catch (error) {
  //   return { error };
  // }
}


export const getRunningCampaignVersions = async (params) => {

  const url = `${API_BASE_URL}/campaign/running/get-versions`;

  let response;

  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: {...params},
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
        return { response };
    }
  } catch (error) {
    return { error };
  }

  // try {
  //   return axios.get('/mock/banner/API_retrieveVersionBanner.json')
  //     .then((response) => {
  //       return { response };
  //     })
  // } catch (error) {
  //   return { error };
  // }
}

export const getRunningConfiguration = async (params) => {

  const url = `${API_BASE_URL}/campaign/running/get-configuration`;

  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: {...params},
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
        return { response };
    }
  } catch (error) {
    return { error };
  }


  // const fileMap = {
  //   TTL: '/mock/banner/API_getRunningTTLConfiguration.json',
  //   BANNER: '/mock/banner/API_getRunningBannerConfiguration.json'
  // };

  // const url = fileMap[params?.templateType] ?? fileMap.TTL;
  // try {
  //   return axios.get(url)
  //     .then((response) => {
  //       return { response };
  //     })
  // } catch (error) {
  //   return { error };
  // }
};

export const updateTemplate = async (params) => {

  const url = `${API_BASE_URL}/template/update`;
  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: {...params},
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
      return { response };
    }
  } catch (error) {
    return { error };
  }

};

export const deleteCampaign = async (params) => {

  const url = `${API_BASE_URL}/campaign/delete`;

  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: {...params},
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
      return { response };
    }
  } catch (error) {
    return { error };
  }
};

export const deleteSingleTemplate = async (params) => {
  const url = `${API_BASE_URL}/template/delete`;
  let response;
  try {
    response = await axios({
      method: 'post',
      url,
      withCredentials: true,
      data: {...params},
      headers: { ...defaultHeaders }
    });
    if (response.data.redirectLocation) {
      window.location.replace(response.data.redirectLocation)
      return { response: { sso: true } };
    } else {
      return { response };
    }
  } catch (error) {
    return { error };
  }
};